import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.list');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-farm-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.list/view.scss */
:host {
  display: block;
}`],
})
export class PortalFarmListComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    public list: any[] = [];
    public search: any = { page: 1, text: '' };
    public facet: any = { lastpage: 1 };
    public movingFarmId = '';

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.init(null);

        const savedSearch = (wiz as any).options?.search;
        if (savedSearch) {
            this.search.page = savedSearch.page || 1;
            this.search.text = savedSearch.text || '';
        }

        await this.load();
        await this.service.render();
    }

    public async load() {
        const res: any = await wiz.call('search', this.search);
        if (res.code === 200) {
            this.list = res.data.list;
            this.facet.lastpage = res.data.lastpage;
        }
    }

    public async searchAction() {
        this.search.page = 1;
        await this.load();
        await this.service.render();
    }

    public async page(p: number) {
        if (p < 1 || p > this.facet.lastpage) return;
        this.search.page = p;
        await this.load();
        await this.service.render();
    }

    public select(item: any) {
        this.router.navigate([
            '/admin/farm/dashboard',
            item.farm_id
        ]);
    }

    public async moveFarmToTrash(event: Event, item: any) {
        event.stopPropagation();

        if (!item?.farm_id || this.movingFarmId) return;

        const confirmed = await this.modalMessage.open({
            title: '농장 삭제',
            messageLines: [
                [
                    { text: item.farm_name, class: 'text-blue-600 font-medium' },
                    { text: '을 삭제하시겠습니까?' }
                ],
                [
                    { text: '삭제된 농장은 휴지통으로 이동되며, 휴지통에서 복구할 수 있습니다.' }
                ]
            ],
            btnAction: '삭제',
            btnClose: '취소',
            btnClass: 'bg-[#cd201f] hover:bg-[#cd201f]/80 px-4 py-1.5 text-white'
        });

        if (!confirmed) return;

        this.movingFarmId = item.farm_id;
        await this.service.render();

        try {
            const res: any = await wiz.call('move_to_trash', { farm_id: item.farm_id });

            if (res?.code === 200) {
                if (this.list.length === 1 && this.search.page > 1) {
                    this.search.page -= 1;
                }

                await this.load();
                await this.modalMessage.open({ message: '농장이 휴지통으로 이동되었습니다.' });
                return;
            }

            if (res?.code === 401 || res?.code === 403) {
                await this.modalMessage.open({ message: '농장 삭제 권한이 없습니다.' });
                return;
            }

            if (res?.code === 409) {
                await this.load();
                await this.modalMessage.open({ message: '이미 휴지통으로 이동된 농장입니다.' });
                return;
            }

            if (res?.code === 404) {
                await this.load();
                await this.modalMessage.open({ message: '이미 삭제되었거나 존재하지 않는 농장입니다.' });
                return;
            }

            await this.modalMessage.open({ message: '농장 삭제에 실패했습니다.' });
        } catch (error) {
            console.error('farm delete error:', error);
            await this.modalMessage.open({ message: '농장 삭제 중 오류가 발생했습니다.' });
        } finally {
            this.movingFarmId = '';
            await this.service.render();
        }
    }

    public onPageChange = async (page: number) => {
        await this.page(page);
    }
}

export default PortalFarmListComponent;